<template>
  <div class="contractAdd">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
<!--        <a @click="contractDialogFormVisible = true">合同下载</a>-->
        <a @click="toModifyPage" v-if="formData.status !== '3' && formData.status !== '4' && formData.status !== '5'  && formData.status !== '6' && formData.status !== '7' && formData.status !== '9' && formData.status !== '10' && formData.status !== '11' && formData.status !== '12' && formData.status !== '14' && formData.status !== '17' && formData.status !== '18' && formData.status !== '19' ">修改</a>
        <a @click="toCustomManagement">返回</a>
      </div>
    </div>
    <form>
      <div class="form-title">主体信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">乙方：</span>
          </div>
          <el-input v-model="formData.leaseName" size="small" style="width: 220px" disabled />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁地址：</span>
          </div>
          <el-input v-model="formData.address" size="small" style="width: 220px" disabled />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁地址：</span>
          </div>
          <el-input v-model="formData.roomInfoArea" size="small" style="width: 220px" disabled>
            <template slot="append">m²</template>
          </el-input>
        </div>
      </div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">签订人：</span>
          </div>
          <el-input v-model="formData.signerName" size="small" style="width: 220px" disabled />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">签订人手机：</span>
          </div>
          <el-input v-model="formData.signerPhone" size="small" style="width: 220px" disabled />
        </div>
        <div></div>
      </div>

      <div class="form-title">合同信息</div>
      <div class="form-line discount-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同类型：</span>
          </div>
          <el-input v-model="formData.type" size="small" style="width: 220px" disabled />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同开始时间：</span>
          </div>
          <el-date-picker v-model="formData.contractStartDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" disabled></el-date-picker>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同结束时间：</span>
          </div>
          <el-date-picker v-model="formData.contractEndDate" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="small" disabled></el-date-picker>
        </div>
      </div>
      <div class="form-line discount-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同签订时间：</span>
          </div>
          <el-date-picker v-model="formData.contractSignDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" disabled></el-date-picker>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">提前付款天数：</span>
          </div>
          <el-input v-model="formData.propertyAheadPayDays" size="small" style="width: 220px" disabled>
            <template slot="append">天</template>
          </el-input>
        </div>
        <div></div>
      </div>

      <div class="form-title">账单信息</div>
      <div v-for="(item, index) in formData.otherPayItemDetails">
        <div class="form-line">
          <div>
            <div class="textBox">
              <span class="line-text">账单类型：</span>
            </div>
            <el-input v-model="item.billType" size="small" disabled></el-input>
          </div>
          <div>
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">账单开始时间：</span>
            </div>
            <el-date-picker v-model="item.billStartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" disabled></el-date-picker>
          </div>
          <div>
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">账单结束时间：</span>
            </div>
            <el-date-picker v-model="item.billEndTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" disabled></el-date-picker>
          </div>
        </div>
        <div class="form-line">
          <div>
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">金额：</span>
            </div>
            <el-input v-model="item.payMoney" type="number" size="small" v-on:blur="otherItemValueChange(index)" disabled>
              <template slot="append">元</template>
            </el-input>
          </div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div class="form-title">其他</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同跟进人：</span>
          </div>
          <el-input v-model="formData.fellowPeopleName" size="small" style="width: 220px;vertical-align: top;" disabled />
        </div>
        <div>
          <div class="textBox">
            <!--<b class="red">*</b>-->
            <span class="line-text">客户来源：</span>
          </div>
          <el-select v-model="formData.customSource" placeholder="请选择" size="mini" style="width: 220px" disabled>
            <el-option
              v-for="item in customSourceList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div></div>
      </div>

      <div class="form-btn-box" style="height: 32px;line-height: 32px;">
        <el-button class="rent-withdrawal-btn" v-if="formData.status === '3' || formData.status === '6' || formData.status === '12' || formData.status === '14'" @click="toRentWithdrawalDetailPage">查看退租协议</el-button>
      </div>
    </form>


    <div class="approveDialogBox">
      <el-dialog title="作废审批" :visible.sync="nullifyDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">作废摘要</div>
            <el-input type="textarea" :rows="4" placeholder="请输入作废摘要" v-model="memo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelNullify">取 消</el-button>
          <el-button size="small" type="primary" @click="nullifyRow">确 定</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import {errorHandler} from '../../../utils/errorHandler'
import {api} from '../../api/InvestmentLeasing'
import {nError, nSuccess} from '../../../utils/notice'
import {treeApi} from '../../api/TreeApi'
import {bus} from '../../../utils/bus'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import InputTree from '../../../components/common/inputs/input-tree'

export default {
  components: {
    InputTree,
    ButtonConfirmNext,
    ButtonCancel,
    ButtonDelete,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'other-contract-current',
  data () {
    return {
      breadcrumb: [{
        value: '其他合约',
        name: 'other-custom-management'
      }, {
        value: '合同列表'
      }],
      accountCode: '',
      accountName: '',
      permissionCodes: '',
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        }
      },
      mainTitle: '合同详情',
      subheading: '',
      currentCode: '',
      isHousingInUnion : false,
      secDiscountOrSecIncreaseRate: '1',
      leaseAheadPayDayType: '1',
      secValue: '',
      trdValue: '',
      enterpriseLoading: false,
      enterpriseList: [],
      signerNameLoading: false,
      signerNameList: [],
      yqPersonList: [],
      enterpriseCode: '',


      customSourceList: [
        {
          code: '自主招商',
          name: '自主招商'
        }, {
          code: '中介介绍',
          name: '中介介绍'
        }
      ],
      incrementalTimePoint: '',
      incrementalTimePointList: [],
      propertyIncrementalTimePointList: [],

      rentActiveNames: [],
      propertyActiveNames: [],
      rentDetailData: false,
      propertyDetailData: false,
      rentTotal1: 0,
      rentTotal2: 0,
      rentTotal1_1: 0,
      rentTotal2_1: 0,
      changeRentData: false,
      propertyTotal1: 0,
      propertyTotal1_1: 0,
      propertyTotal2: 0,
      propertyTotal2_1: 0,
      changePropertyData: false,


      formData: {
        leaseName: '',
        signerName: '',
        signerPhone: '',
        address: '',
        roomInfoArea: '',

        type: '',
        contractSignDate: '',
        contractStartDate: '',
        contractEndDate: '',
        propertyAheadPayDays: '',

        otherPayItemDetails: [
          {
            payMoney: '',
            billStartTime: '',
            billEndTime: '',
            feeType: '其他',
            memo: ''
          }
        ],

        fellowPeopleName: '',           // 合同跟进人名称
        fellowPeopleCode: '',           // 合同跟进人code
        customSource: '',
        memo: ''

      },
      // 审批信息
      approveDialog: false,
      accountList: [],
      contractCode: '',
      approveAccountCode: '',
      digest: '',
    }
  },
  created () {
    this.currentCode = this.$route.params.id
    this.accountCode = bus.global.accountCode
    this.accountName = bus.global.accountName
    this.permissionCodes = bus.global.permissionCodes
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();

    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }

    let oneYearLateYear = year + 1
    let oneYearLateMonth = month
    let oneYearLateDate = ''
    if(strDate > 1){
      oneYearLateDate = strDate-1
    } else {
      oneYearLateMonth = month-1
      if (oneYearLateMonth < 10) {
        oneYearLateMonth= "0" + oneYearLateMonth
      }
      if( oneYearLateMonth === 0 ){
        oneYearLateMonth = 12
        oneYearLateYear = year
      }
      oneYearLateDate = new Date(oneYearLateYear, oneYearLateMonth, 0).getDate()
    }
    if (oneYearLateDate >= 0 && oneYearLateDate <= 9) {
      oneYearLateDate = "0" + oneYearLateDate;
    }
    // this.formData.contractStartDate = `${year}-${month}-${strDate}`
    // this.formData.contractSignDate = `${year}-${month}-${strDate}`
    // this.formData.contractEndDate = `${oneYearLateYear}-${month}-${strDate}`
    this.getYqPersonList()
    this.getOtherContractManagerByCode()
  },
  mounted () {},
  methods: {
    getOtherContractManagerByCode () {
      this.$axios.get(`${api.getOtherContractManagerByCode}/${this.currentCode}`, {})
        .then(res => {
          this.formData = res.data.data
        })
        .catch(errorHandler('获取合同失败'))
    },
    toModifyPage () {
      this.$router.push({
        path: `/other_contract_modify/${this.currentCode}`
      })
    },
    toCustomManagement () {
      this.$router.push({
        name: 'other-filing-contract'
      })
    },

    toRenewalPage () {
      this.$router.push({
        path: `/other_contract_renewal/${this.currentCode}`
      })
    },
    toRentChangePage () {
      this.$router.push({
        path: `/other_contract_rent_change/${this.currentCode}`
      })
    },
    toRentWithdrawalPage () {
      this.$router.push({
        path: `/other_rent_withdrawal/${this.currentCode}`
      })
    },
    toRentWithdrawalDetailPage () {
      this.$router.push({
        path: `/other_filing_rent_withdrawal_detail/${this.currentCode}`
      })
    },
    // 合同删除
    deleteContractByCodes () {
      this.$confirm('是否确认删除该合同？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.$axios.post(api.deleteOtherContractApproveByCode, {
            code: this.currentCode
          })
            .then(res => {
              if (res.data.retCode === 1) {
                nSuccess('删除成功')
                this.toCustomManagement()
              }
            })
            .catch(errorHandler('删除失败'))
        })
        .catch(() => {
          console.log('取消删除')
        })
    },

    // 签订人搜索
    enterpriseManagerMethod (query) {
      this.signerNameLoading = true;
      this.$axios.post(api.getEnterpriseManagerList, {
        enterpriseCode: this.enterpriseCode,
        searchKey: query || ''
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.signerNameLoading = false;
            let data = res.data.data
            this.signerNameList = data
          }
        })
        .catch(errorHandler('获取签订人失败'))
    },

    // 获取跟进人列表
    getYqPersonList () {
      this.$axios.post(api.getYqPersonList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.yqPersonList = data
          }
        })
        .catch(errorHandler('获取跟进人列表失败'))
    },

    otherItemValueChange (index) {
      if (this.formData.others[index].payMoney) {
        this.formData.others[index].payMoney = parseFloat(this.formData.others[index].payMoney).toFixed(2)
      } else {
        this.formData.others[index].payMoney = '0.00'
      }
    },


    // 增加其他费用
    addOtherItemLine () {
      let obj = {
        payMoney: '',
        billStartTime: '',
        billEndTime: '',
        feeType: '其他',
        memo: ''
      }
      this.formData.otherPayItemDetails.push(obj)
    },

    // 删减其他费用
    removeOtherItemLine (index) {
      this.formData.otherPayItemDetails.splice(index, 1)
    },

    // 获取审批人员列表
    getAccountListByCode () {
      this.$axios.post(api.getAccountListByCode, {
        accountCode: this.accountCode
      })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (data.length > 0) {
              data.map(v => {
                v._labelName = `${v.name} / ${v.actualName}`
              })
            }
            this.accountList = data
          }
        })
        .catch(errorHandler('获取审批人员列表失败'))
    },

    // 保存合同
    confirm () {
      if (!this.formData.leaseName) {
        nError('请输入乙方名称')
        return false
      }
      if (!this.formData.signerName) {
        nError('请输入签订人姓名')
        return false
      }
      if (!this.formData.signerPhone) {
        nError('请输入签订人电话')
        return false
      }
      this.yqPersonList.map(v => {
        if (v.code === this.formData.fellowPeopleCode) {
          this.formData.fellowPeopleName = v.name
        }
      })
      this.$axios.post(api.saveOtherContractApprove, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('保存成功')
            this.toCustomManagement()
          }
        })
        .catch(errorHandler('保存失败'))
    },
    confirmAndApproval () {
      if (!this.formData.signerName) {
        nError('请选择签订人姓名')
        return false
      }
      if (!this.formData.fellowPeopleCode) {
        nError('请选择合同跟进人')
        return false
      }
      this.yqPersonList.map(v => {
        if (v.code === this.formData.fellowPeopleCode) {
          this.formData.fellowPeopleName = v.name
        }
      })
      this.formData.roomInfoSeat = this.formData.officeSeat
      this.$axios.post(api.saveOtherContractApprove, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            let contractCode = res.data.data
            if (contractCode) {
              this.contractCode = contractCode
              this.approveDialog = true
              nSuccess('保存成功')
            }
          }
        })
        .catch(errorHandler('保存失败'))

    },
    cancel () {
      this.toCustomManagement()
    },

    // 取消审批
    cancelApprove () {
      this.approveDialog = false
      this.approveAccountCode = ''
      this.digest = ''
    },

    // 提交审批
    confirmApprove () {
      let obj = {
        contractCode: this.contractCode,
        sponsorAccountCode: this.accountCode,
        sponsorAccountName: this.accountName,
        digest: this.digest,
        approveType: '4',
      }
      this.$axios.post(api.submitOtherContractApprove, obj)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('提交审批成功')
            this.toCustomManagement()
          }
        })
        .catch(errorHandler('提交审批失败'))
    },


    // 取消审批
    cancelNullify () {
      this.nullifyDialog = false
      this.memo = ''
    },
    // 合同作废
    nullifyRow () {
      this.$axios.post(api.cancelOtherContractApprove, {
        code: this.currentCode,
        memo: this.memo
      })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('作废提交成功')
            this.toCustomManagement()
          }
        })
        .catch(errorHandler('提交失败'))
    },

  },
  watch: {
    // 'formData.signerCode': {
    //   handler(newName, oldName) {
    //     this.signerNameList.map(v => {
    //       if (v.code === this.formData.signerCode) {
    //         this.formData.signerName = v.name
    //         this.formData.signerPhone = v.phone
    //       }
    //     })
    //   },
    //   deep: true
    // },

  }
}
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.header-btn-box a{
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover{
  color: #00a0e6;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
}
.form-title {
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  padding-left: 5px;
  margin: 20px 0 10px 0;
  border-left: 3px solid #00a0e6;
}
.form-line {
  margin: 5px 0 10px;
  display: flex;
  justify-content: flex-start;
}
.form-line>div {
  width: 33%;
}
.line-text{
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 160px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  margin: 30px auto;
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="less">
.contractAdd {
  .el-input--mini {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}

.el-select .el-input .el-select__caret {
  height: 32px;
}
.el-input-group__append {
  padding: 0 5px!important;
  width: auto!important;
}
.el-input-group__prepend {
  padding: 0 5px!important;
  width: auto!important;
}
.discount-line {
  .el-input-group__append, .el-input-group__prepend {
    padding: 0 20px!important;
  }
}

.el-collapse-item__arrow {
  line-height: 48px!important;
}

.contractAdd {
  .el-input__inner {
    padding: 0 0 0 15px;
  }
  .el-input--prefix .el-input__inner {
    padding: 0 0 0 30px;
  }
}

.approveDialogBox {
  text-align: left;
  .el-dialog {
    width: 800px;
  }
  .approveMainBox {
    text-align: center;
  }
  .approve_title {
    width: 120px;
  }
  .approveFlexBox {
    width: 500px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: flex-start;
  }
}

.rent-active {
  .el-range-editor--small {
    .el-range-separator {
      line-height: 30px;
      padding: 0;
    }
  }
}
.rent-withdrawal-btn {
  border: 1px solid #d7d7d7;
  color: #48576a;
  padding: 8px 16px;
  background-color: #F7F7F7;
}
.rent-withdrawal-btn:hover {
  color: #FFFFFF;
  background-color: #f25721;
}
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/OtherContracts/OtherFilingContractCurrent.vue